import styled from 'react-emotion';

import Style from '../../styles/common';

const AuthForm = styled('div')`
  margin: 0 auto;
  max-width: ${Style.MEASUREMENT.PAGE.MAX_WIDTH};
  padding: ${Style.SPACING.XL} ${Style.SPACING.L};
`;

export default AuthForm;


// WEBPACK FOOTER //
// ./src/views/Auth/AuthForm.js